export enum MENUS {
  PATIENT_DATA = 'PATIENT_DATA',
  MODELS = 'MODELS',
  DRUG_INTERACTIONS = 'DRUG_INTERACTIONS',
  PERSONAL_SETTINGS = 'PERSONAL_SETTINGS',
  POLICY = 'POLICY',
  HELP = 'HELP',
  HISTORY = 'HISTORY',
  PRESCRIBER_DATA = 'PRESCRIBER_DATA',
  News = 'News',
  OFFICE = 'OFFICE',
}

export const DONT_SHOW_RQE_IN_PDF_KEY = -1;
